/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Addr_Wiz_TitleInputs */

const cs_addr_wiz_title = /** @type {(inputs: Addr_Wiz_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Návrhy doplnění adres`)
};

const en_addr_wiz_title = /** @type {(inputs: Addr_Wiz_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Address suggestions`)
};

/**
* | output |
* | --- |
* | "Address suggestions" |
*
* @param {Addr_Wiz_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_wiz_title = /** @type {((inputs?: Addr_Wiz_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Wiz_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_wiz_title(inputs)
	return cs_addr_wiz_title(inputs)
});